import { render, staticRenderFns } from "./home-other-earning.vue?vue&type=template&id=a3dd59e6&"
import script from "./home-other-earning.vue?vue&type=script&lang=js&"
export * from "./home-other-earning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports